// Date-preset helpers for the P&L page (PLReport.js).
// Pure functions — kept import-light so they are unit-testable.

// Format from local date parts, not toISOString (UTC): east-of-UTC users would
// otherwise get Jan 1 rendered as Dec 31 and a stray prior-year column.
// Exported so every date the P&L page sends to the API is built the same way.
export const toLocalISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// Compute the date range for a preset. All month windows snap to the 1st of
// the month so the first column is never a partial mid-month slice.
export const getDateRangeForPreset = (preset) => {
  const end = new Date();
  let start = new Date();

  switch (preset) {
    case 'last_6_months':
      // 1st of the month 5 months back: 6 whole monthly columns.
      start = new Date(end.getFullYear(), end.getMonth() - 5, 1);
      break;
    case 'last_year':
      // 1st of the month 11 months back: 12 whole monthly columns
      // (incl. the current month), never a partial mid-month first column.
      start = new Date(end.getFullYear(), end.getMonth() - 11, 1);
      break;
    case 'this_year':
      start = new Date(end.getFullYear(), 0, 1);
      break;
    default:
      start = new Date(end.getFullYear(), end.getMonth() - 5, 1);
  }

  return {
    start: toLocalISO(start),
    end: toLocalISO(end),
  };
};

// Default preset: YTD from May onwards; Jan-Apr fall back to the trailing
// 12 months so the default view is never just a few months wide.
export const getDefaultPreset = () => (new Date().getMonth() > 3 ? 'this_year' : 'last_year');
